import React, { useState, useEffect } from "react";
import { Grid, Modal, useMediaQuery } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import KendoButton from "assets/theme/components/button/kendo";
import CustomMultipleSelect from "../../AddVendor/components/CustomMultiSelect";
import TreeViewLocationFilter from "pages/Locations/components/TreeViewDropDown";
import { useFormik } from "formik";
import * as Yup from "yup";
import { modalContainerStyle } from "pages/components/common/Styles";

const AssignAssetsModel = ({ open, handleClose, asset, refresh, setRefresh }) => {
  console.log("Delete asset", asset);

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [loading, setLoading] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);

  const validationSchema = Yup.object({
    locationId: Yup.number().required("This field is required"),
  });

  const formik = useFormik({
    initialValues: {
      locationId: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const body = new FormData();
      body.append("locationId", values.locationId);
    },
  });

  useEffect(() => {
    formik.setFieldValue("locationId", selectedLocation?.id);
  }, [selectedLocation]);

  return (
    <SoftBox>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="assign-device-modal"
        aria-describedby="assign-device-modal-description"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <SoftBox sx={modalContainerStyle}>
          <SoftTypography variant="h4" component="h2" gutterBottom mb={2}>
            Assign Assets
          </SoftTypography>
          <Grid item xs={12} md={12} lg={12} container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <SoftTypography
                fontSize="small"
                fontWeight="bold"
                letterSpacing={0.3}
                variant="h5"
                mb={0.5}
              >
                Select Location
              </SoftTypography>
              <TreeViewLocationFilter
                onChangeHandler={setSelectedLocation}
                dropdownWidth={isMobile ? "280px" : "365px"}
              />
              {formik.errors.locationId ? (
                <div className="form-error error">{formik.errors.locationId}</div>
              ) : null}
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <SoftTypography
                fontSize="small"
                fontWeight="bold"
                letterSpacing={0.3}
                variant="h5"
                mb={0.5}
              >
                Asset
              </SoftTypography>
              <CustomMultipleSelect />
            </Grid>
          </Grid>

          <SoftBox>
            <Grid container justifyContent="flex-end" mt={3}>
              <Grid item lg={4}>
                <SoftButton onClick={handleClose} color="dark" sx={{ mr: 1 }}>
                  Cancel
                </SoftButton>
              </Grid>
              <Grid item lg={4}>
                <KendoButton type="button" label={"Submit"} loading={loading} />
              </Grid>
            </Grid>
          </SoftBox>
        </SoftBox>
      </Modal>
    </SoftBox>
  );
};

export default AssignAssetsModel;
